/***
*
*   USERS
*   Enables an admin to manage the users in their application
*
**********/

import React, { Fragment, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { ViewContext, Card, AccountNav, Table,
  Button, Animate, useAPI, usePermissions } from 'components/lib';

export function Users(props){

  const context = useContext(ViewContext);
  const permissions = usePermissions();
  const data = useAPI('/api/account/users');
  const [users, setUsers] = useState([]);

  function invite(){

    context.modal.show({
      title: 'Agregar Usuario',
      form: {
        email: {
          label: 'Correo',
          type: 'email',
          required: true,
        },
        permission: {
          label: 'Permisos',
          type: 'select',
          default: 'user',
          options: permissions?.data?.list?.filter(x => x.value !== 'owner') 
        },
      },
      buttonText: 'Enviar invitación',
      text: 'Para invitar a más de un usuario, separe los correos con una coma',
      url: '/api/invite',
      method: 'POST',

      }, (form, res) => {

        // add the invited user to the
        const state = [...users];

        if (!state.find(x => x.id === res.id)){
          state.push({

            id: res.id,
            name: '',
            email: res.email,
            date_created: res.date_sent,
            permission: res.permission || 'user',
            status: 'Invited',
            actions: {

              invite: resendInvite,
              delete: deleteInvite

            },
          });

          setUsers(state);

        }
    });
  }

  function editUser(data, callback){

    context.modal.show({
      title: 'Actualización de Usuario',
      form: {
        id: {
          type: 'hidden',
          value: data.id
        },
        name: {
          label: 'Name',
          type: 'text',
          required: true,
          value: data.name,
          errorMessage: 'Por favor ingrese un nombre'
        },
        email: {
          label: 'Email',
          type: 'email',
          value: data.email,
          required: true,
        },
        permission: {
          label: 'Permission',
          type: data.permission === 'owner' ? null : 'select',
          options: permissions?.data?.list?.filter(x => x.value !== 'owner') ,
          default: data.permission
        }
      },
      buttonText: 'Save',
      url: '/api/user',
      method: 'PATCH'

    }, (res) => {

      context.notification.show(data.name + ' fue actualizado', 'success', true);
      callback(res);

    });
  }

  function deleteUser(data, callback){

    context.modal.show({
      title: 'Eliminación de Usuario',
      form: {
        id: {
          type: 'hidden',
          value: data.id
        }
      },
      buttonText: 'Eliminar Usuario',
      text: `Estás seguro que quieres borrar a ${data.name}?`,
      url: '/api/user',
      method: 'DELETE'

    }, () => {

      context.notification.show(data.name + ' fue eliminado', 'success', true);
      callback();

    });
  }

  function deleteInvite(data, callback){
    
    context.modal.show({
      title: 'Borrar Invitación Invite',
      form: {
        id: {
          type: 'hidden',
          value: data.id
        }
      },
      buttonText: 'Borrar Invitación',
      text: `Estás seguro que quieres eliminar la invitación para ${data.email}?`,
      url: '/api/invite',
      method: 'DELETE'

    }, () => {

      context.notification.show(`Invitación a ${data.email} ha sido eliminada`, 'success', true);
      callback();

    });
  }

  async function resendInvite(data){
    try {

      await axios({ 
        
        url: '/api/invite',
        method: 'post',
        data: { email: data.email }
      
      });
      
      context.notification.show(`Invitación reenviada a ${data.email}`, 'success', true);

    }
    catch(err){

      context.handleError(err);

    }
  }
  
  useEffect(() => {

    // format the user list
    let list = [];

    if (data?.data?.users?.length){
      list = data.data.users.map(x => {
        return {

          id: x.id,
          name: x.name,
          email: x.email,
          date_created: x.date_created,
          permission: x.permission,
          status: 'Registered'

        }
      })
    }

    if (data?.data?.invites?.length){
      data.data.invites.forEach(x => {
        list.push({

          id: x.id,
          name: '',
          email: x.email,
          date_created: x.date_sent,
          permission: x.permission || 'user',
          status: 'Invited',

        });
      });
    }

    setUsers(list);

  }, [data]);

  // attach the per row actions for invites
  if (users.length){
    users.forEach(u => {
      if (u.status === 'Invited'){
        u.actions = {

          invite: resendInvite,
          delete: deleteInvite

        }
      }
    })
  }

  return (
    <Fragment>

      <AccountNav />
      <Animate>

        <section className='title-row'>
          <h2>Administración de usuarios</h2>
          <Button small text='Agregar usuario' action={ invite }/>
        </section>

        <Card>
          <Table
            search
            className='restrict-width'
            data={ users }
            loading={ data?.loading }
            show={['email', 'name', 'date_created', 'last_login', 'permission', 'status']}
            badge={{ col: 'status', color: 'blue', condition: [

              { value: 'registered', color: 'green' },
              { value: 'invited', color: 'blue' }

            ]}}
            actions={{ edit: editUser, delete: deleteUser, email: true }}
          />
        </Card>

      </Animate>
    </Fragment>
  );
}
